export const VROONG_COLORS = {
  PRIMARY_GREEN: '#05CD82',
  GREEN_LIGHT: '#26D494',
  GREEN_DARK: '#04B374',
  BLUE: '#0091FF',
  BLUE_LIGHT: '#1A9EFF',
  BLUE_DARK: '#007CE6',
  DARK: '#1a1a1a',
  WHITE: '#FFFFFF',
} as const;

export const DEFAULT_STATS = {
  completedCount: 0,
  rejectedCount: 0,
  acceptanceRate: 0,
  deliveryFee: 0,
  morningLunchPeakCount: 0,
  afternoonNonPeakCount: 0,
  eveningPeakCount: 0,
  nightPeakCount: 0,
} as const;

export const API_CONFIG = {
  TIMEOUT: 30000,
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
} as const;

export const AUTH_PATHS = {
  NO_AUTH_REQUIRED: ['/login', '/password-setup', '/registration-request', '/register', '/find-account'],
} as const;

export const DATE_FORMAT = {
  YYYYMMDD: 'YYYYMMDD',
  YYYY_MM_DD: 'YYYY-MM-DD',
} as const;

export const USER_TYPE = {
  RIDER: 'rider',
  SUPPLIER: 'supplier',
  HEADQUARTERS: 'HEADQUARTERS',
} as const;

export const TRANSACTION_TYPE = {
  DEPOSIT: 'D',
  WITHDRAWAL: 'W',
  REWARD_POINT: 'RP',
  REWARD_WITHDRAWAL: 'RW',
} as const;

export const DEDUCTION_TARGET = {
  RIDER: 'R',
  SUPPLIER: 'S',
} as const;

export const CALC_TYPE = {
  FIXED: '1',
  RATE: '2',
} as const;

export const TERMINATED_YN = {
  YES: 'Y',
  NO: 'N',
} as const;

export const PRE_ACCT_YN = {
  YES: 'Y',
  NO: 'N',
} as const;
